import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axiosInstance from "../utils/axiosSetup.js";
import moment from "moment";
import usePermissionChecker from "../action/checkPermission.jsx";

const Dashboard = () => {
    const user = JSON.parse(localStorage.getItem('userInfo'));
    const { checkPermission } = usePermissionChecker();

    const [employee, setEmployees] = useState([]);
    const [projects_count, setProjectsCount] = useState([]);
    const [clients_count, setClientsCount] = useState([]);
    const [employees_count, setEmployeesCount] = useState([]);
    const [currentDayLeaves, setCurrentDayLeaves] = useState([]);
    const [upcomingLeaves, setUpcomingLeaves] = useState([]);
    const [holidays, setHolidays] = useState([]);
    const [EMNotFilled, setEMNotFilled] = useState([]);
    const [leavesCred, serLeavesCred] = useState([]);

    const fetchData = async () => {
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/dashboard`)
            .then(response => {
                setEmployees(response.data.data.employees.data);
                setProjectsCount(response.data.data.projects_count);
                setClientsCount(response.data.data.clients_count);
                setEmployeesCount(response.data.data.employees_count);
                setCurrentDayLeaves(response.data.data.currentDayLeaves.data);
                setUpcomingLeaves(response.data.data.upcomingLeaves.data);
                serLeavesCred(response.data.data.leave_credebility);
            })
            .catch(error => {
                console.error('Error', error);
                setEmployees([]);
                setProjectsCount([]);
                setClientsCount([]);
                setEmployeesCount([]);
                setCurrentDayLeaves([]);
                setUpcomingLeaves([]);
                serLeavesCred([]);
            });
    }

  const fetchHolidays = async () => {
    try {
      const response = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/holidays`);
      setHolidays(response.data.data.holidays);

      let em_not_filled = await axiosInstance.get(`${process.env.REACT_APP_API_URL}/em_not_filled_by_me`);
      em_not_filled = em_not_filled.data.data;
      em_not_filled = em_not_filled.length > 0 ? em_not_filled[0]["not_filled_dates"].split(", ") : [];
      setEMNotFilled(em_not_filled);
    } catch (error) {
      console.error("Error fetching holidays", error);
      setHolidays([]);
      setEMNotFilled([]);
    }
  };

  useEffect(() => {
    fetchData();
    fetchHolidays();
  }, []);

  // Filter holidays that occur after current date
  const currentDate = new Date();
  const upcomingHolidays = holidays.filter((holiday) => new Date(holiday.date) > currentDate);

  // Filter birthdays that occur in the current month
  const currentMonthBirthdays = employee.filter((employee) => moment(employee.dob).format("MMMM") === moment().format("MMMM"));

  //Calculate Duration of Employees
  const calculateDuration = (joinedDate) => {
    const currentDate = new Date();
    const joined = new Date(joinedDate);

    const years = Math.floor(
      (currentDate - joined) / (365.25 * 24 * 60 * 60 * 1000)
    );
    const months = Math.floor(
      ((currentDate - joined) % (365.25 * 24 * 60 * 60 * 1000)) /
        (30.44 * 24 * 60 * 60 * 1000)
    );
    const days = Math.floor(
      (((currentDate - joined) % (365.25 * 24 * 60 * 60 * 1000)) %
        (30.44 * 24 * 60 * 60 * 1000)) /
        (24 * 60 * 60 * 1000)
    );

    return `${years} Years, ${months} Months, ${days} Days`;
  };

  return (
    <div className="content container-fluid p-3">

      {/* Dashboard Header */}
      {(user.role_name !== 'Super-Admin') ? (
        <div className="row">
          <div className="col-xxl-5 col-lg-5 col-md-5 col-sm-12">
              <div className="card flex-fill">
                  <div className="card-body">
                      <div className="row">
                          {/* <div className="col-lg-5 col-md-5">
                              <img src="/assets/img/dashboard1.jpg" alt="dashboard" />
                          </div> */}

                          <div className="col-lg-12 col-md-12">
                              <div className="card employee-welcome-card flex-fill mt-4">
                                  <div className="card-body">
                                      <div className="welcome-info">
                                          <div className="welcome-content">
                                              <h4>Welcome, {user.name || ''}</h4>
                                          </div>
                                      </div>
                                      <div className="welcome-btn">
                                          <Link to="/profile" className="btn">View Profile</Link>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
          </div>

          <div className="col-xxl-5 col-lg-5 col-md-5 col-sm-12">
              <div className="card flex-fill">
                  <div className="card-body">
                      <div className="statistic-header">
                          <h4>Attendance & Leaves</h4>
                      </div>
                      <div className="attendance-list">
                          <div className="row">
                              {
                                  leavesCred.length > 0 && (
                                      leavesCred.map((cred, index) => (
                                          <div className="col-md-6" key={index}>
                                              <div className="attendance-details">
                                                  <h5 className="text-purple mb-1">{cred.leave_type}</h5>
                                                  <div>Total Leaves: <span  className="text-success">{cred.total_leaves} Hrs.</span></div>
                                                  <div>Used Leaves: <span  className="text-danger">{cred.used_leaves} Hrs.</span></div>
                                                  <div>Remaining Leaves: <span  className="text-info">{cred.total_leaves-cred.used_leaves} Hrs.</span></div>
                                              </div>
                                          </div>
                                      ))
                                  )
                              }

                              {/* <div className="col-md-4">
                                  <div className="attendance-details">
                                      <h4 className="text-success">04</h4>
                                      <p>Leaves Absent</p>
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="attendance-details">
                                      <h4 className="text-purple">0</h4>
                                      <p>Pending Approval</p>
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="attendance-details">
                                      <h4 className="text-info">214</h4>
                                      <p>Working Days</p>
                                  </div>
                              </div>
                              <div className="col-md-4">
                                  <div className="attendance-details">
                                      <h4 className="text-danger">2</h4>
                                      <p>Loss of Pay</p>
                                  </div>
                              </div> */}
                          </div>
                      </div>
                      <div className="view-attendance">
                          <Link to="/leaves">Apply Leave</Link>
                      </div>
                  </div>
              </div>
          </div>

          <div className="col-xxl-2 col-lg-2 col-md-2 col-sm-12">
            <div className="card flex-fill">
              <div className="card-body mainHeadingWrap">
                <h4 className="card-title absentHeading">
                  EM Not Filled
                  {EMNotFilled.length > 0 && (
                    <span className="badge bg-inverse-danger spinner-grow pt-2 ms-2 float-end">
                      {EMNotFilled.length}
                    </span>
                  )}
                </h4>
                <div className="table-responsive fixedEMAccrodion">
                  <table className="table custom-table mb-0">
                    <tbody>
                      {EMNotFilled.length > 0 ? (
                        EMNotFilled.map((employee, index) => (
                          <tr key={index}>
                            <td className="text-danger">{employee}</td>
                          </tr>
                        ))
                      ) : (
                        <tr className="text-center">
                          <td className="text-success h3" colSpan="1">
                            No pending log found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
          <div className="page-header mt-2 mb-3">
          <div className="row">
            <div className="col-sm-12">
              <h3 className="page-title breadcrumb">
                Welcome &nbsp;{" "}
                <span className="breadcrumb-item active fst-italic font-monospace">
                  {" "}
                  {user.name}
                </span>
              </h3>
            </div>
          </div>
        </div>
      )}
      {/* Header - END */}


      <div className="row mainWidge">
        {checkPermission("Employees") && (
          <div className="col-xxl-2 col-lg-3 col-md-6">
            <div className="card dash-widget">
              <div className="card-body carbodyWrap">
                <span className="dash-widget-icon">
                  <i className="fa-solid fa-user-plus"></i>
                </span>
                <div className="dash-widget-info">
                  <h3>{employees_count}</h3>
                </div>
              </div>
              <Link to="/employees">Current Employee Details</Link>
            </div>
          </div>
        )}

        {checkPermission("Client") && (
          <div className="col-xxl-2 col-lg-3 col-md-6">
            <div className="card dash-widget">
              <div className="card-body carbodyWrap">
                <span className="dash-widget-icon">
                  <i className="fa-solid fa-users"></i>
                </span>
                <div className="dash-widget-info">
                  <h3>{clients_count}</h3>
                </div>
              </div>
              <Link to="/clients">Current Client Details</Link>
            </div>
          </div>
        )}

        {checkPermission("Projects") && (
          <div className="col-xxl-2 col-lg-3 col-md-6">
            <div className="card dash-widget">
              <div className="card-body carbodyWrap">
                <span className="dash-widget-icon">
                  <i className="fa-solid fa-rocket"></i>
                </span>
                <div className="dash-widget-info">
                  <h3>{projects_count}</h3>
                </div>
              </div>
              <Link to="/projects">Current Project Details</Link>
            </div>
          </div>
        )}

        {checkPermission("Morning Time Logs") && (
          <div className="col-xxl-2 col-lg-3 col-md-6">
            <div className="card dash-widget">
              <div className="card-body carbodyWrap">
                  <span className="dash-widget-icon"><i className="fa-solid fa-list-ul"></i></span>
              </div>
              <div className="dash-widget-info boxsAlign">
                  <h4><Link to="/timelog/manageTimeMorning">Morning Time Logs</Link></h4>
              </div>
            </div>
          </div>
        )}

        {checkPermission("Evening Time Logs") && (
          <div className="col-xxl-2 col-lg-3 col-md-6">
            <div className="card dash-widget">
              <div className="card-body carbodyWrap">
                <span className="dash-widget-icon"><i className="fa-solid fa-history"></i></span>
              </div>
              <div className="dash-widget-info boxsAlign">
                  <h4><Link to="/timelog/manageTimeEvening">Evening Time Logs</Link></h4>
                </div>
            </div>
          </div>
        )}

        {checkPermission("Daily Reports") && (
          <div className="col-xxl-2 col-lg-3 col-md-6">
            <div className="card dash-widget">
              <div className="card-body carbodyWrap">
                <span className="dash-widget-icon"><i className="fa-solid fa-file-alt"></i></span>
              </div>
              <div className="dash-widget-info boxsAlign">
                  <h4><Link to="/em-not-filled">Daily Reports</Link></h4>
                </div>
            </div>
          </div>
        )}
      </div>


      <div className="row">
        {checkPermission("Today Absent Details") && (
          <div className="col-md-12 col-lg-6 col-xl-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <h4 className="card-title absentHeading">
                  Today Absent Details
                  <span className="badge bg-inverse-danger ms-2">
                    {currentDayLeaves.length}
                  </span>
                </h4>
                {currentDayLeaves.length > 0 ? (
                  currentDayLeaves.slice(0, 3).map((leave) => (
                    <div className="leave-info-box" key={leave.id}>
                      <div className="media d-flex align-items-center">
                        <div className="media-body flex-grow-1">
                          <div className="text-sm my-0">
                            {leave.applicant_name || ""}
                            <span className="text-secondary">
                              {" "}
                              ({leave.designation || ""})
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center mt-1">
                        <div className="col-6">
                          <small className="mb-0">
                            {leave.from_date} - {leave.to_date}
                          </small>
                        </div>
                        <div className="col-6 text-end">
                          {leave.status === "0" && (
                            <span className="badge bg-inverse-warning">
                              Pending
                            </span>
                          )}
                          {leave.status === "1" && (
                            <span className="badge bg-inverse-success">
                              Approved
                            </span>
                          )}
                          {leave.status === "2" && (
                            <span className="badge bg-inverse-danger">
                              Declined
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="leave-info-box text-center">
                    No leave found
                  </div>
                )}

                <div className="load-more text-center">
                  <Link to="/leaves">View all leaves</Link>
                </div>
              </div>
            </div>
          </div>
        )}

        {checkPermission("Leaves") && (
          <div className="col-md-12 col-lg-6 col-xl-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <h4 className="card-title absentHeading">
                  Leave Details{" "}
                  <span className="badge bg-inverse-danger ms-2">
                    {upcomingLeaves.length}
                  </span>
                </h4>
                {upcomingLeaves.length > 0 ? (
                  upcomingLeaves.slice(0, 3).map((leave) => (
                    <div className="leave-info-box" key={leave.id}>
                      <div className="media d-flex align-items-center">
                        <div className="media-body flex-grow-1">
                          <div className="text-sm my-0">
                            {leave.applicant_name || ""}
                            <span className="text-secondary">
                              {" "}
                              ({leave.designation || ""})
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center mt-1">
                        <div className="col-6">
                          <small className="mb-0">
                            {leave.from_date} - {leave.to_date}
                          </small>
                        </div>
                        <div className="col-6 text-end">
                          {leave.status === "0" && (
                            <span className="badge bg-inverse-warning">
                              Pending
                            </span>
                          )}
                          {leave.status === "1" && (
                            <span className="badge bg-inverse-success">
                              Approved
                            </span>
                          )}
                          {leave.status === "2" && (
                            <span className="badge bg-inverse-danger">
                              Declined
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="leave-info-box text-center">
                    No upcoming leave found
                  </div>
                )}

                <div className="load-more text-center">
                  <Link to="/leaves">View all leaves</Link>
                </div>
              </div>
            </div>
          </div>
        )}

        {checkPermission("Holiday") && (
          <div className="col-md-12 col-lg-6 col-xl-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <h4 className="card-title absentHeading">
                  Holiday Details{" "}
                  <span className="badge bg-primary ms-2">
                    {upcomingHolidays.length}
                  </span>
                </h4>
                {upcomingHolidays.length > 0 ? (
                  upcomingHolidays.slice(0, 2).map((holiday) => (
                    <div className="leave-info-box" key={holiday.id}>
                      <div className="media d-flex align-items-center">
                        <div className="media-body flex-grow-1">
                          <div className="text-sm my-0">
                            {holiday.name || ""}
                          </div>
                        </div>
                      </div>
                      <div className="row align-items-center mt-1">
                        <div className="col-12">
                          <small className="mb-0">
                            {holiday.date
                              ? moment(
                                  holiday.date,
                                  "YYYY-MM-DD HH:mm:ss"
                                ).format("dddd, MMMM Do YYYY")
                              : ""}
                          </small>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="leave-info-box text-center">
                    No upcoming holiday found
                  </div>
                )}

                <div className="load-more text-center">
                  <Link to="/holidays">View all holidays</Link>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {checkPermission("Birthday Details") && (
          <div className="col-md-12 col-lg-6 col-xl-6 d-flex">
            <div className="card flex-fill">
              <div className="card-body">
                <h4 className="card-title absentHeading">
                  Birthday Details{" "}
                  <span className="badge bg-primary ms-2">
                    {currentMonthBirthdays.length}
                  </span>
                </h4>

                <div className="table-responsive">
                  <table className="table custom-table mb-0">
                    <thead>
                      <tr>
                        <th>NAME</th>
                        <th>BIRTHDAY</th>
                        <th>JOINING DATE</th>
                        <th>DURATION</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentMonthBirthdays.length > 0 ? (
                        currentMonthBirthdays.map((employee) => (
                          <tr key={employee.id}>
                            <td>{employee.name}</td>
                            <td>{employee.dob}</td>
                            <td>{employee.joined_date}</td>
                            <td>{calculateDuration(employee.joined_date)}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="4">No birthday found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>


      {/* <div className="row mainRow">
        <div className="col-md-6 col-lg-6 col-xl-6 d-flex">
          <div className="card flex-fill">
            <div className="card-body">
              <div className="row mb-2 mainHeadingWrap">
                <div className="col-lg-6 col-md-6 pt-1 mt-1 holiHeading">
                  <h4>
                    Upcoming Leaves{" "}
                    <span className="text-primary bg-light rounded py-1 px-2 ms-2">
                      {upcomingLeaves.length}
                    </span>
                  </h4>
                </div>
                <div className="col-lg-6 col-md-6" align="right">
                  <Link to="/leaves" className="btn btn-sm btn-primary">
                    View All
                  </Link>
                </div>
              </div>
              {upcomingLeaves.length > 0 ? (
                upcomingLeaves.slice(0, 4).map((leave) => {
                  return (
                    <>
                      {user.id === leave.applicant_id ? (
                        <div className="leave-info-box" key={leave.id}>
                          <div className="row align-items-center mt-1">
                            <div className="col-6">
                              <small className="mb-0">
                                {leave.from_date} - {leave.to_date}
                              </small>
                            </div>
                            <div className="col-6 text-end">
                              {leave.status === "0" && (
                                <span className="badge bg-inverse-warning">
                                  Pending
                                </span>
                              )}
                              {leave.status === "1" && (
                                <span className="badge bg-inverse-success">
                                  Approved
                                </span>
                              )}
                              {leave.status === "2" && (
                                <span className="badge bg-inverse-danger">
                                  Declined
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  );
                })
              ) : (
                <div className="leave-info-box text-center">
                  No upcoming leave found
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-6 col-xl-6 d-flex">
          <div className="card flex-fill">
            <div className="card-body">
              <div className="row mb-2 mainHeadingWrap">
                <div className="col-lg-6 col-md-6 pt-1 mt-1 holiHeading">
                  <h4>
                    Holiday Details {" "}
                    <span className="text-primary bg-light rounded py-1 px-2 ms-2">
                      {upcomingHolidays.length}
                    </span>
                  </h4>
                </div>
                <div className="col-lg-6 col-md-6" align="right">
                  <Link to="/holidays" className="btn btn-sm btn-primary">
                    View All
                  </Link>
                </div>
              </div>
              {upcomingHolidays.length > 0 ? (
                upcomingHolidays.slice(0, 3).map((holiday) => (
                  <div className="leave-info-box" key={holiday.id}>
                    <div className="holiday-calendar">
                      <div className="row">
                        <div className="col-lg-1 col-md-1 pt-2">
                          <div className="holiday-calendar-icon">
                            <img
                              className="bg-secondary"
                              src={`${process.env.REACT_APP_URL}/assets/img/icons/holiday-calendar.svg`}
                              alt="Icon"
                            />
                          </div>
                        </div>
                        <div className="col-lg-11 col-md-11">
                          <div className="holiday-calendar-content">
                            <div>{holiday.name || ""}</div>
                            <p>
                              {holiday.date
                                ? moment(
                                    holiday.date,
                                    "YYYY-MM-DD HH:mm:ss"
                                  ).format("dddd, MMMM Do YYYY")
                                : ""}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
                ) : (
                <div className="leave-info-box text-center">
                  No holiday found
                </div>
              )}
            </div>
          </div>
        </div>    
      </div> */}
    </div>
  );
};

export default Dashboard;
